// extracted by mini-css-extract-plugin
export default {"heading":"Testimonial_heading__p-ng9","content":"Testimonial_content__df0M1"};